module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-2.bf611c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-2.jpg
// module id = 1VSD
// module chunks = 1